import { useLang } from "@/lib/i18n";
import PolicyPage from "@/components/PolicyPage";

export default function ShippingPolicy() {
  const { t } = useLang();
  return (
    <PolicyPage
      testid="shipping-policy"
      title={t.ship.title}
      intro={t.ship.intro}
      sections={[
        { title: t.ship.t1Title, body: t.ship.t1Body, placeholder: t.ship.placeholder },
        { title: t.ship.t2Title, body: t.ship.t2Body },
        { title: t.ship.t3Title, body: t.ship.t3Body },
      ]}
    />
  );
}
